(() => {
  const desktopQuery = window.matchMedia('(min-width: 990px) and (hover: hover)');
  const closeTimers = new WeakMap();

  function setExpanded(details, expanded) {
    details.open = expanded;
    details.querySelector(':scope > summary')?.setAttribute('aria-expanded', String(expanded));
  }

  function clearClose(details) {
    const timer = closeTimers.get(details);
    if (timer) window.clearTimeout(timer);
  }

  function scheduleClose(details) {
    clearClose(details);
    closeTimers.set(details, window.setTimeout(() => setExpanded(details, false), 180));
  }

  function initialize(root = document) {
    root.querySelectorAll('.header__inline-menu details').forEach((details) => {
      if (details.dataset.croqueHoverReady === 'true') return;
      details.dataset.croqueHoverReady = 'true';
      const summary = details.querySelector(':scope > summary');
      summary?.setAttribute('aria-expanded', String(details.open));
      details.addEventListener('toggle', () => summary?.setAttribute('aria-expanded', String(details.open)));
      details.addEventListener('mouseenter', () => {
        if (!desktopQuery.matches) return;
        clearClose(details);
        setExpanded(details, true);
      });
      details.addEventListener('mouseleave', () => {
        if (desktopQuery.matches) scheduleClose(details);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  desktopQuery.addEventListener('change', (event) => {
    if (!event.matches) {
      document.querySelectorAll('.header__inline-menu details[open]').forEach((details) => setExpanded(details, false));
    }
  });
})();
